import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    this.initializeApp();
  }

  dark = false;

  contentPages = [
    new ContentPage()
      .setTitle('Startseite')
      .setUrl('/app/tabs/home')
      .setIcon('home-outline'),
    new ContentPage()
      .setTitle('News')
      .setUrl('/app/tabs/news')
      .setIcon('globe-outline'),
  ];

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}


class ContentPage {
  title: string;
  setTitle(value: string) {
    this.title = value;
    return this;
  }

  url: string;
  setUrl(value: string) {
    this.url = value;
    return this;
  }

  click: string;
  setClick(value) {
    this.click = value;
    return this;
  }

  icon: string;
  setIcon(value: string) {
    this.icon = value;
    return this;
  }

  img: string;
  setImg(value: string) {
    this.img = value;
    return this;
  }
}
